import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "adviser",

  initialState: {
    adviserModel: null,
  },

  reducers: {
    setAdviserModel: (state, { payload: adviserModel }) => ({
      ...state,
      adviserModel,
    }),
  },
});

export const { setAdviserModel } = slice.actions;

export default slice.reducer;

export const getAdviserModel = (store) => store.adviser.userModel;